import Vue from 'vue';
import UsersTableOperation from './UsersTableOperation.vue';

export default Vue.extend({
    template: `<UsersTableOperation :params='params' />`,
    data: function () {
        return {};
    },
    components: {
        UsersTableOperation
    },
    beforeMount() { },
    mounted() { },
    methods: {},
});